var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main", style: { height: _vm.scrollerHeight } },
    [
      _c("div", { staticClass: "title" }, [_vm._v("图表组件")]),
      _vm._v(" "),
      _c(
        "draggable",
        {
          staticClass: "chart-container-widget-list",
          attrs: {
            list: _vm.designer.chartWidgets,
            "item-key": "key",
            group: { name: "dragGroup", pull: "clone", put: false },
            clone: _vm.handleContainerWidgetClone,
            "ghost-class": "ghost",
            sort: false,
            disabled: true,
            move: _vm.checkContainerMove,
          },
          on: { end: _vm.onContainerDragEnd },
        },
        _vm._l(_vm.designer.chartWidgets, function (element) {
          return _c(
            "div",
            {
              key: element.key,
              staticClass: "chart-container-widget-item",
              attrs: { title: element.displayName },
              on: {
                click: function ($event) {
                  return _vm.addChartContainerByDbClick(element)
                },
              },
            },
            [
              _c("svg-icon", {
                attrs: {
                  "icon-class": element.icon,
                  "class-name": "color-svg-icon",
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.getWidgetLabel(element)))]),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }